import { render } from "./TheZoneCreation.vue?vue&type=template&id=38963eba"
import script from "./TheZoneCreation.vue?vue&type=script&lang=js"
export * from "./TheZoneCreation.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__